/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateStatus
 */
export interface BulkUpdateStatus {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateStatus
     */
    ids: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateStatus
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateStatus
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateStatus
     */
    markPackageAsDelivered?: boolean;
    /**
     * When true, allow moving a completed package (Delivered/Out for Delivery) back to a receiving status. Defaults to false so an over-broad selection cannot silently reverse delivered packages.
     * @type {boolean}
     * @memberof BulkUpdateStatus
     */
    allowStatusRegression?: boolean;
    /**
     *
     * @type {string}
     * @memberof BulkUpdateStatus
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateStatus
     */
    courierId?: string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateStatus
     */
    cashierId?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateStatus
     */
    id?: number;
}

/**
 * Check if a given object implements the BulkUpdateStatus interface.
 */
export function instanceOfBulkUpdateStatus(value: object): value is BulkUpdateStatus {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BulkUpdateStatusFromJSON(json: any): BulkUpdateStatus {
    return BulkUpdateStatusFromJSONTyped(json, false);
}

export function BulkUpdateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'status': json['status'],
        'sendEmail': json['sendEmail'] == null ? undefined : json['sendEmail'],
        'markPackageAsDelivered': json['markPackageAsDelivered'] == null ? undefined : json['markPackageAsDelivered'],
        'allowStatusRegression': json['allowStatusRegression'] == null ? undefined : json['allowStatusRegression'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'cashierId': json['cashierId'] == null ? undefined : json['cashierId'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function BulkUpdateStatusToJSON(json: any): BulkUpdateStatus {
    return BulkUpdateStatusToJSONTyped(json, false);
}

export function BulkUpdateStatusToJSONTyped(value?: BulkUpdateStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'status': value['status'],
        'sendEmail': value['sendEmail'],
        'markPackageAsDelivered': value['markPackageAsDelivered'],
        'allowStatusRegression': value['allowStatusRegression'],
        'userId': value['userId'],
        'courierId': value['courierId'],
        'cashierId': value['cashierId'],
        'id': value['id'],
    };
}

